import React from 'react';
import PropTypes from 'prop-types';
import { FDCheckboxInput, FDStack, FDHeadlineText } from '@facet-wealth/design';
import { useDataAttrs } from 'Helpers/Testing';

export const CheckboxMultiPicklist = ({
  label,
  value,
  direction,
  options,
  onChange,
  ...rest
}) => {
  const checked = new Set(!value ? [] : value);
  return (
    <FDStack direction="column" spacing={2} {...useDataAttrs(rest)} flex={1}>
      <FDHeadlineText size="sm" value={label} color="textSecondary" />
      <FDStack direction={direction} spacing={direction === 'horizontal' ? 3 : 1}>
        {options.map(option => (
          <FDCheckboxInput
            key={option.id}
            label={option.prompt}
            checked={checked.has(option.id)}
            onChange={(_, shouldBeChecked) => {
              if (shouldBeChecked) {
                checked.add(option.id);
              }
              if (!shouldBeChecked) {
                checked.delete(option.id);
              }
              onChange([...checked]);
            }}
          />
        ))}
      </FDStack>
    </FDStack>
  );
};

CheckboxMultiPicklist.defaultProps = {
  value: [],
  direction: 'column',
};

CheckboxMultiPicklist.propTypes = {
  value: PropTypes.array,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(['column', 'row']),
};
